import Logo from "@/components/Logo";
import { ArrowUpRight, Instagram, MapPin } from "lucide-react";
import {
    useSiteSettings,
    useContentSection,
    instaUrlFrom,
} from "@/lib/siteData";

export default function Footer() {
    const settings = useSiteSettings();
    const sec = useContentSection("footer");

    return (
        <footer className="relative overflow-hidden border-t border-ink/10 pb-10 pt-20">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
                    <div>
                        <Logo />
                        <p className="mt-5 max-w-xs text-sm leading-relaxed text-dim">
                            {sec.body}
                        </p>
                    </div>
                    <div>
                        <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-neon-cyan">
                            Contato
                        </p>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li>
                                <span className="inline-flex items-center gap-2 text-dim" data-testid="footer-phone"><span aria-hidden="true">☎</span>{settings.phone_display}</span>
                            </li>
                            <li>
                                <a
                                    href={instaUrlFrom(settings)}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-instagram"
                                    className="inline-flex items-center gap-2 text-dim transition-colors hover:text-neon-cyan"
                                >
                                    <Instagram className="h-3.5 w-3.5" />
                                    {settings.instagram_handle}
                                </a>
                            </li>
                            <li className="flex items-center gap-2 text-dim">
                                <MapPin className="h-3.5 w-3.5" />
                                Ubatuba — SP, Brasil
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-mono2 text-[10px] font-semibold uppercase tracking-[0.3em] text-neon-cyan">
                            Navegue
                        </p>
                        <ul className="mt-5 space-y-3 text-sm text-dim">
                            {[
                                ["passeios", "Passeios"],
                                ["clima", "Clima ao vivo"],
                                ["contato", "Contato"],
                            ].map(([id, label]) => (
                                <li key={id}>
                                    <a
                                        href={`#${id}`}
                                        data-testid={`footer-link-${id}`}
                                        className="transition-colors hover:text-neon-cyan"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            document
                                                .getElementById(id)
                                                ?.scrollIntoView({
                                                    behavior: "smooth",
                                                });
                                        }}
                                    >
                                        {label}
                                    </a>
                                </li>
                            ))}
                            <li><a href="/politica-de-cancelamento" data-testid="footer-link-cancelamento" className="transition-colors hover:text-neon-cyan">Cancelamento e reembolso</a></li>
                        </ul>
                    </div>
                </div>

                <p
                    aria-hidden="true"
                    className="text-stroke-soft mt-16 select-none whitespace-nowrap text-center font-display text-[16vw] font-black uppercase leading-none md:text-[11rem]"
                >
                    PARADISE
                </p>

                <div className="mt-12 flex justify-center">
                    <span className="flex items-center gap-2.5 font-mono2 text-[10px] font-semibold uppercase tracking-[0.25em] text-dim">
                        Desenvolvido por
                        <a
                            href="https://www.instagram.com/ernstudioofc?xtok=ank3OWxlejIwNzVm"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Visitar o Instagram da ERN Studio"
                            data-testid="ern-studio-instagram"
                            className="inline-flex items-center gap-2.5 rounded-sm transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-neon-cyan"
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/ern-studio.png`}
                                alt="Logo da ERN Studio"
                                data-testid="ern-studio-logo"
                                className="h-9 w-9 rounded-full"
                            />
                            <span className="text-ink">ERN Studio</span>
                        </a>
                    </span>
                </div>

                <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-ink/10 pt-6 font-mono2 text-[10px] uppercase tracking-[0.2em] text-dim/70">
                    <span>
                        © {new Date().getFullYear()} Jetski Paradise Ubatuba
                    </span>
                    <span>
                        Clima por{" "}
                        <a
                            href="https://open-meteo.com/"
                            target="_blank"
                            rel="noreferrer"
                            className="underline underline-offset-4 hover:text-neon-cyan"
                        >
                            Open-Meteo.com
                        </a>
                    </span>
                </div>
            </div>
        </footer>
    );
}
